/* eslint-disable */
// ################# New ###################
import React, { useEffect, useState } from 'react';
import jwt_decode from "jwt-decode";
import axios from 'axios';
import config from '../../../config/config';
import DynamicPaginatedTable from '../DynamicPaginatedTable/DynamicPaginatedTable';
import styles from './TableView.module.css';

const { API_BASE_URL } = config;

const TableView = () => {
  const UserToken = keycloak.token;
  let username = '';
  let Email = '';
  if(UserToken !== undefined || UserToken !== null){
    const decoded = jwt_decode(UserToken);
    username = decoded.preferred_username
    Email = decoded.email
  } else{
    console.log("test null..!")
  }
  
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);

  const itemsPerPage = 10;

  const fetchData = async (page = 1) => {
    setLoading(true);
    const token = localStorage.getItem('ApiToken');

    try {
      const response = await axios.post(
        `${API_BASE_URL}/api/file-upload-maker-table`,
        {
          user_id: username,
          pageNumber: page,
          pageSize: itemsPerPage
        },
        {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: 'Basic YWRtaW4xOjEyMw==',
          }
        }
      );
      const resData = response.data;
      setData(resData.data || []);
      setTotalRecords(resData.totalCount || 0);
      // console.log("Fetched page:", page, "Records:", resData.data.length);
    } catch (error) {
      console.error('Failed to fetch data:', error);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData(1);
  }, []);

  const handlePageChange = (page) => {
    fetchData(page);
  };

  const handleCSVDownload = () => {
    alert("Download clicked!");
  };

  const allColumns = [
    { header: "ID", accessor: "id" },
    { header: "File Name", accessor: "file_name" },
    { header: "Created Date", accessor: "created_date" },
    { header: "Updated Date", accessor: "updated_date" },
    { header: "Status", accessor: "status" },
    { header: "Comments", accessor: "comments" },
    { header: "Approved Name", accessor: "approved_name" },
  ];

  const selectedColumns = allColumns.filter(col =>
    ["id", "file_name", "created_date", "updated_date", "status", "approved_name"].includes(col.accessor)
  );

  // const columns = [
  //   { Header: 'ID', accessor: 'id' },
  //   { Header: 'File Name', accessor: 'file_name' },
  //   { Header: 'Created Date', accessor: 'created_date' },
  //   { Header: 'Updated Date', accessor: 'updated_date' },
  //   { Header: 'Status', accessor: 'status' },
  //   { Header: 'Approved Name', accessor: 'approved_name' },
  // ];

  return (
    <div className={styles.filter_panel_container}>
      {/* <div className="container mt-4"> */}
      <h5>Uploaded Files</h5>
      <DynamicPaginatedTable
        data={data}
        columns={allColumns}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
        isCustomOpen={true}
        totalRecords={totalRecords}
        handleCSVDownload={handleCSVDownload}
        dataLoading={loading}
      />
    </div>
    // </div>
  );
};

export default TableView;

// ####################################################################

// import React, { useState, useEffect } from 'react';
// import jwt_decode from "jwt-decode";
// import axios from 'axios';
// import ReactPaginate from 'react-paginate';
// import Modal from '../../ReusableTable/DssModel/DssModel';
// // import Modal from './DssModel/DssModel';
// // import { MESSAGE_TYPE } from '../../constants';
// import { MESSAGE_TYPE } from '../../../constants';
// // import ColumnSelector from './DssColumnSelectionModal/ColumnSelectionModal';
// import ColumnSelector from '../../ReusableTable/DssColumnSelectionModal/ColumnSelectionModal';
// import './TableView.css';
// import swal from 'sweetalert';
// import config from '../../../config/config';
// import GridLoadingSpinner from '../../GridLoadingSpinner/GridLoadingSpinner';
// import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
// import HtmlComp from '../../ReusableTable/DssHtmlComp/DssHtmlComp';

// const { API_BASE_URL } = config;

// const TableView = ({ data, columns, itemsPerPage, onPageChange, isCustomOpen, totalRecords, handleCSVDownload, dataLoading }) => {
//   const { showPopup } = usePopupManager();
//   const [currentPage, setCurrentPage] = useState(0);
//   const [currentData, setCurrentData] = useState([]);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.accessor));
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [progress, setProgress] = useState(0);

//   const UserToken = keycloak.token;
//   let username = '';
//   let Email = '';

//   if (UserToken !== undefined || UserToken !== null) {
//       const decoded = jwt_decode(UserToken);
//       username = decoded.preferred_username;
//       Email = decoded.email;
//   }

//   useEffect(() => {
//       const offset = currentPage * itemsPerPage;
//       setCurrentData(data);
//       setSelectedRows(selectedRows.filter(rowId => data.slice(offset, offset + itemsPerPage).some(row => row.id === rowId)));
//   }, [currentPage, data, itemsPerPage]);

//   const handlePageClick = ({ selected }) => {
//       setCurrentPage(selected);
//       onPageChange(selected + 1);
//   };

//   const fileCountClicked = (buttonValue) => {
//       const formdata = new FormData();
//       formdata.append('selectedIndex', sessionStorage.getItem("SelectedFolderFile"));
//       formdata.append("file_name", buttonValue);
//       formdata.append("useremail", Email);

//       const config = {
//           method: 'post',
//           url: `${API_BASE_URL}/api/store-process-download-web-count`,
//           headers: {
//               'Authorization': 'Basic YWRtaW4xOjEyMw==',
//           },
//           data: formdata
//       };

//       axios(config).then(function (response) {
//           const fileNotDownloadedList = response.data.file_not_download_list;
//           if (fileNotDownloadedList.length !== 0) {
//               let tableRows = fileNotDownloadedList.map(file => `<tr><td>${file}</td></tr>`).join('');
//               let message = `
//                   Bulk download limit reached. Please check the file not downloaded list:
//                   <table border="1">
//                       <tr><th>File Not Downloaded</th></tr>
//                       ${tableRows}
//                   </table>
//               `;
//               showPopup({
//                   type: MESSAGE_TYPE.INFORMATION,
//                   contextText: MESSAGE_TYPE.INFORMATION,
//                   info: <HtmlComp htmlString={message} />,
//               });
//           }
//       });
//   };

//   const handleDownload = () => {
//       if (selectedRows.length === 0) {
//           swal("Select columns", "Please select at least one row to download.", 'warning');
//       } else {
//           fileCountClicked(selectedRows);
//           setLoading(true);
//           setProgress(0);
//           const formdata = new FormData();
//           formdata.append('selectedIndex', sessionStorage.getItem("SelectedFolderFile"));
//           formdata.append("file_name", selectedRows);

//           const config = {
//               method: 'post',
//               url: `${API_BASE_URL}/api/store-process-download-web`,
//               headers: {
//                   'Authorization': 'Basic YWRtaW4xOjEyMw==',
//               },
//               data: formdata,
//               responseType: 'blob',
//               onDownloadProgress: (progressEvent) => {
//                   if (progressEvent.lengthComputable) {
//                       const total = progressEvent.total;
//                       const current = progressEvent.loaded;
//                       setProgress(Math.round((current / total) * 100));
//                   }
//               },
//           };

//           axios(config).then(function (response) {
//               const blob = new Blob([response.data], { type: 'application/zip' });
//               const downloadUrl = window.URL.createObjectURL(blob);
//               const link = document.createElement('a');
//               link.href = downloadUrl;
//               link.download = 'files.zip';
//               document.body.appendChild(link);
//               link.click();
//               setTimeout(() => {
//                   window.URL.revokeObjectURL(downloadUrl);
//                   document.body.removeChild(link);
//               }, 100);
//               setLoading(false);
//           });
//       }
//   };

//   const handleColumnChange = (newSelectedColumns) => {
//       setSelectedColumns(newSelectedColumns);
//       setIsModalOpen(false);
//   };

//   const handleRowSelect = (id) => {
//       setSelectedRows(prev => prev.includes(id) ? prev.filter(r => r !== id) : [...prev, id]);
//   };

//   const handleSelectAll = () => {
//       if (currentData.every(row => selectedRows.includes(row.id))) {
//           setSelectedRows(selectedRows.filter(id => !currentData.some(row => row.id === id)));
//       } else {
//           setSelectedRows([...selectedRows, ...currentData.filter(row => !selectedRows.includes(row.id)).map(row => row.id)]);
//       }
//   };

//   return (
//       <div>
//           <div className="table-container">
//               <div className="d-flex justify-content-between align-items-center mb-2">
//                   <p className="total-records mb-0">Total Records: {totalRecords}</p>
//               </div>
//               <table className="table table-bordered table-striped">
//                   <thead className="table-light">
//                       <tr>
//                           <th>
//                               <input
//                                   type="checkbox"
//                                   checked={currentData.length > 0 && currentData.every(row => selectedRows.includes(row.id))}
//                                   onChange={handleSelectAll}
//                               />
//                           </th>
//                           <th>ID</th>
//                           <th>File Name</th>
//                           <th>Created Date</th>
//                           <th>Updated Date</th>
//                           <th>Status</th>
//                           <th>Approved Name</th>
//                           <th>Download</th>
//                       </tr>
//                   </thead>
//                   <tbody>
//                       {dataLoading ? (
//                           <tr>
//                               <td colSpan={8} className="text-center py-4">
//                                   <div style={{ fontSize: "18px", fontWeight: "bold", color: "#0983b1" }}>Please wait..</div>
//                                   <GridLoadingSpinner />
//                               </td>
//                           </tr>
//                       ) : (
//                           currentData.map((row) => (
//                               <tr key={row.id}>
//                                   <td>
//                                       <input
//                                           type="checkbox"
//                                           checked={selectedRows.includes(row.id)}
//                                           onChange={() => handleRowSelect(row.id)}
//                                       />
//                                   </td>
//                                   <td>{row.id.toString().padStart(5, '0')}</td>
//                                   <td>{row.file_name}</td>
//                                   <td><i className="fa fa-calendar me-1 text-muted"></i>{row.created_date}</td>
//                                   <td><i className="fa fa-calendar me-1 text-muted"></i>{row.updated_date}</td>
//                                   <td>
//                                       <span className={`badge ${row.status === 'Approved' ? 'bg-success' : 'bg-warning text-dark'}`}>
//                                           {row.status}
//                                       </span>
//                                   </td>
//                                   <td>{row.approved_name}</td>
//                                   <td className="text-center">
//                                       <i
//                                           className="fa fa-download text-primary"
//                                           style={{ cursor: 'pointer', fontSize: '18px' }}
//                                           onClick={() => fileCountClicked(row.file_name)}
//                                           title="Download"
//                                       />
//                                   </td>
//                               </tr>
//                           ))
//                       )}
//                   </tbody>
//               </table>
//           </div>

//           <div className="table-controls d-flex justify-content-between align-items-center">
//               {isCustomOpen && (
//                   <div>
//                       <button onClick={handleCSVDownload} className="btn btn-outline-primary me-2">DATA DOWNLOAD</button>
//                       <button onClick={() => setIsModalOpen(true)} className="btn btn-outline-secondary">CUSTOMIZE TABLE</button>
//                       <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
//                           <ColumnSelector
//                               columns={columns}
//                               selectedColumns={selectedColumns}
//                               onColumnChange={handleColumnChange}
//                           />
//                       </Modal>
//                   </div>
//               )}
//               <div className="pagination-container">
//                   <ReactPaginate
//                       previousLabel="Previous"
//                       nextLabel="Next"
//                       breakLabel="..."
//                       breakClassName="break-me"
//                       pageCount={Math.ceil(totalRecords / itemsPerPage)}
//                       marginPagesDisplayed={2}
//                       pageRangeDisplayed={5}
//                       onPageChange={handlePageClick}
//                       containerClassName="pagination"
//                       activeClassName="active"
//                   />
//               </div>
//           </div>

//           {loading && (
//               <div className="loading-overlay">
//                   <GridLoadingSpinner />
//                   <div className="text-center mt-3" style={{ fontSize: "20px", fontWeight: "bold", color: "#0983b1" }}>
//                       <p>Please wait</p>
//                       <p>Files being Downloaded</p>
//                   </div>
//               </div>
//           )}
//       </div>
//   );
// };

// export default TableView;

